import React from 'react';
import IconButton from '../../IconButton/component.js';
import Button from '../../Button/component.js';
var ToolbarButton = function ToolbarButton(_ref) {
  var _ref$text = _ref.text,
    text = _ref$text === undefined ? null : _ref$text,
    type = _ref.type,
    _ref$icon = _ref.icon,
    icon = _ref$icon === undefined ? null : _ref$icon,
    handler = _ref.handler,
    isActive = _ref.isActive,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === undefined ? false : _ref$isDisabled;
  return /*#__PURE__*/React.createElement(React.Fragment, null, icon ? /*#__PURE__*/React.createElement(IconButton, {
    ariaLabel: type,
    icon: {
      prefix: 'far',
      iconName: icon
    },
    isDisabled: isDisabled,
    onMouseDown: handler,
    isActive: isActive,
    variant: 'ghost',
    colorScheme: 'gray',
    size: 'compact'
  }) : /*#__PURE__*/React.createElement(Button, {
    ariaLabel: type,
    isDisabled: isDisabled,
    onMouseDown: handler,
    isActive: isActive,
    variant: 'ghost',
    colorScheme: 'gray',
    size: 'sm'
  }, text));
};
export { ToolbarButton };